import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "../../Button";
import { Close } from "@/icons";
import "./AddNewModalHeader.scss";
import { ReactNode } from "react";

type AddNewModalHeaderProps = {
  closeButton?: string;
  onCloseClick?: () => void;
  children?: ReactNode;
};

export const AddNewModalHeader = ({
  closeButton = "Annulla",
  onCloseClick,
  children,
}: AddNewModalHeaderProps) => {
  return (
    <header className="ui-add-new-modal-header bg-white">
      <Dialog.Title className="fs-7 md-fs-custom text-slate-20 fw-bold">
        {children}
      </Dialog.Title>
      <Dialog.Close asChild className="ui-add-new-modal-header-close">
        <Button
          size="4"
          variant={"closeModal"}
          aria-label="Chiudi modale"
          onClick={onCloseClick}
        >
          <div className={"close-label-mobile"}>{closeButton}</div>
          <Close className="ml-x8" width={32} height={32} />
        </Button>
      </Dialog.Close>
    </header>
  );
};
